import type { ICommand } from '@model-framework/command';
import type { PositionSet } from './PositionSet';
import type { IPositionSetRepository } from './IPositionSetRepository';
import type { DBPath } from 'balus-common';
import { PositionSetRepository } from './infrastructure/PositionSetRepository';

export class PositionSetCreateCommand implements ICommand {
  private readonly repository: IPositionSetRepository;

  constructor(
    private readonly toValue: PositionSet,
    path: DBPath
  ) {
    this.repository = new PositionSetRepository(path);
  }

  do(): void {
    this.repository.saveMany(this.toValue).then();
  }

  undo(): void {
    this.repository.deleteMany(this.toValue.allIds()).then();
  }

  redo(): void {
    this.do();
  }

  async canUndo(): Promise<boolean> {
    const currentPositions = await this.repository.getMany(this.toValue.allIds());
    return currentPositions.isEqual(this.toValue);
  }

  async canRedo(): Promise<boolean> {
    const currentPositions = await this.repository.getMany(this.toValue.allIds());
    return currentPositions.isEmpty();
  }
}
